export const API_BASE_URL = process.env.REACT_APP_API_BASE || 'https://api.smarteaming.com';

export async function apiCall<T = any>(
  endpoint: string,
  options?: { method?: 'GET' | 'POST' | 'DELETE' | 'PATCH'; body?: any; headers?: Record<string, string>; signal?: AbortSignal }
): Promise<T> {
  const { method = 'POST', body, headers, signal } = options ?? {};
  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
  const defaultHeaders: Record<string, string> = body && !isFormData ? { 'Content-Type': 'application/json' } : {};
  const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
    method,
    credentials: 'include',
    headers: { ...defaultHeaders, ...headers },
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
    signal,
  });
  const contentType = response.headers?.get?.('content-type') || '';
  // Some native/test fetch adapters expose json() without a Headers object.
  // Prefer the real content type, but retain compatibility with those adapters.
  const isJson = contentType
    ? contentType.includes('application/json')
    : typeof response.json === 'function';

  if (!response.ok) {
    let data: any;
    try { data = isJson ? await response.json() : { error: await response.text() }; } catch {}
    const err: any = new Error(`API error: ${response.status}`);
    err.status = response.status;
    err.data = data;
    if (response.status === 403 && data?.error === 'feature_disabled') {
      err.handled = true;
      try {
        window.dispatchEvent(new CustomEvent('api:feature-disabled', {
          detail: { feature: data?.feature, endpoint },
        }));
      } catch {}
    }
    throw err;
  }
  if (isJson) return response.json();
  // Wrap plain-text responses so callers always get an object
  const text = await response.text();
  return { message: text } as T;
}
